<template>
  <div class="supplies-view width-responsiveness--centralized">
    <div class="supplies-view__container">
      <subheader
        title="Pedidos de Insumos"
        :centralized="true"
        :path="'/dashboard'"
      >
        <div
          slot="info"
          class="supplies-view__header-info"
        >
          <img
            src="/static/images/icon-info.svg"
            alt="informacao"
          >
          <md-tooltip
            md-delay="400"
            md-direction="top"
          >
            Pedidos referentes aos últimos 3 meses
          </md-tooltip>
        </div>
        <button
          class="supplies-view__header-btn outline"
          @click="handleClick('gestao-de-insumos/filtrar')"
        >
          <img src="/static/images/icon-filter-new.svg">
          Filtrar
        </button>
        <button
          class="supplies-view__header-btn"
          @click="handleClick('gestao-de-insumos/criar-solicitacao')"
        >
          <img src="/static/images/icon-plus.svg">
          Novo Pedido
        </button>
      </subheader>
      <div class="supplies-view__container">
        <div
          v-if="supplyLoading"
          class="supplies-view__loading"
        >
          <spinner />
        </div>
        <request-list
          v-else
          :items="supplyList"
        />
      </div>
    </div>
    <page-scroll-top />
    <div class="supplies-view__footer width-responsiveness--centralized">
      <p><b>Prazo de entrega:</b> Até 4 dias úteis para o atendimento e entrega dos insumos.</p>
    </div>
  </div>
</template>

<script>
import SubHeader from '@/components/common/SubHeader'
import PageScrollTop from '@/components/common/PageScrollTop'
import RequestList from './SuppliesRequestList.vue'
import { mapGetters, mapActions } from 'vuex'
import Spinner from '../common/Spinner.vue'

export default {
  name: 'SuppliesView',
  components: {
    subheader: SubHeader,
    'page-scroll-top': PageScrollTop,
    RequestList,
    Spinner
  },
  computed: {
    ...mapGetters(['profile', 'supplyList', 'supplyLoading'])
  },
  mounted () {
    this.supplyUpdateList(this.$route.query)
  },
  methods: {
    ...mapActions(['supplyUpdateList']),
    handleClick(route) {
      this.$router.push(route)
    },
    submitAnalyticsEvent (action) {
      this.$analytics.pushAnalyticsEvent('ga-event', {
        category: 'Gestão de Insumos',
        action: action,
        'id-user': this.profile.id,
        'id-lab': this.profile.id_laboratory,
        'name-lab': this.profile.laboratoryName
      })
    }
  }
}
</script>

<style lang="scss">
.supplies-view {
  font-family: 'Exo 2', sans-serif;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  height: calc(100% - 58px);
  margin-top: 150px;
  &__container {
    padding-bottom: 40px;
    width: 100%;
  }
  &__header {
    &-info {
      position: relative;
      top: 5px;
      right: -6px;
    }
    &-btn {
      background-color: #7F1A54;
      height: 40px;
      width: 154px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-transform: uppercase;
      font-size: 13px;
      font-family: 'Exo 2', sans-serif;
      font-weight: 600;
      border-radius: 4px;
      &.outline {
        background-color: transparent;
        border: 2px solid #7F1A54;
        color: #7F1A54;
        margin-right: 10px;
        width: auto;
        padding: 0 30px;
      }
      img {
        margin-right: 5px;
      }
    }
  }
  .subheader__content__right-side {
    display: flex;
    align-items: center;
  }
  .subheader__title {
    h2 {
      font-weight: 700 !important;
      font-size: 23px !important;
    }
  }
  &__footer {
    background-color: #ebebeb;
    position: fixed;
    bottom: 0;
    height: 58px;
    border-top: 1px solid #ccc;
    width: 100%;
    display: flex;
    align-items: center;

    p {
      font-size: 14px;
      color: #727272;
    }

    b {
      color: #7F1A54;
    }
  }
  &__loading {
    min-height: 40vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
